<!-- Content Header (Page header) -->
<section class="content-header p-1">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Información</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Información</li>
        </ol>
      </div>
    </div>
  </div>
</section>

<section class="content p-0">
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <div class="text-center">
              <div class="profile-image">
                <img
                  [src]="imageToShow"
                  alt="Imagen de perfil"
                />
              </div>
              <div class="profile-info">
                <h2>
                  {{
                    sesion?.nombre +
                      " " +
                      sesion?.apellido_paterno +
                      " " +
                      sesion?.apellido_materno
                  }}
                </h2>
                <table>
                  <tr>
                    <td><strong>Colaborador:</strong></td>
                    <td>{{ sesion.numero_colaborador }}</td>
                  </tr>
                  <tr>
                    <td><strong>Plantel:</strong></td>
                    <td>{{ sesion?.sucursal?.descripcion }}</td>
                  </tr>
                  <tr>
                    <td><strong>Puesto:</strong></td>
                    <td>{{ sesion?.puesto?.descripcion }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  (click)="openPdf()"
                >
                  Reglamento
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  (click)="openDocuments()"
                >
                  Documentación
                </button>
              </div>
            </div>
          </div>
          <div class="col-6">
            <app-calendar></app-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
